import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '輸入商品一覧',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
};
